var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "elementType": "div",
      "customClass": _vm.$props.customsClasses
    }
  }, _vm._l(_vm.itemsToPurchase, function (item, index) {
    var _vm$translations, _vm$translations2, _vm$translations3, _vm$translations4;
    return _c('CustomContainer', {
      key: index,
      staticClass: "buy-panel-size-selection-form-container-sizeqty",
      attrs: {
        "elementType": "div"
      }
    }, [_vm.$props.showSizeTiles && _vm.showSizeDropdown ? _c('TileSelect', {
      attrs: {
        "headingLabel": (_vm$translations = _vm.translations) === null || _vm$translations === void 0 ? void 0 : _vm$translations.buyPanelSize,
        "tileList": _vm.sizes.short_display_values || _vm.sizes.values,
        "tileKeyList": _vm.sizes.identifier,
        "itemSelected": _vm.itemsToPurchase[0].size,
        "buyPanelIsLoading": _vm.buyPanelIsLoading
      },
      on: {
        "on-click-item": _vm.onChangeSize
      }
    }, [_c('CustomText', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.translations.hasOwnProperty('sizeGuidePageUrl') && _vm.translations.sizeGuidePageUrl !== '',
        expression: "translations.hasOwnProperty('sizeGuidePageUrl') && translations.sizeGuidePageUrl !== ''"
      }],
      attrs: {
        "customClass": "tile-selectors__charts",
        "href": (_vm$translations2 = _vm.translations) === null || _vm$translations2 === void 0 ? void 0 : _vm$translations2.sizeGuidePageUrl,
        "target": "_blank",
        "elementType": "a",
        "text": " - ".concat((_vm$translations3 = _vm.translations) === null || _vm$translations3 === void 0 ? void 0 : _vm$translations3.buyPanelSizeGuide)
      }
    })], 1) : _vm._e(), _vm.$props.showQuantityTiles && !_vm.buyPanelConfiguration.quantity_select_hide ? _c('TileSelect', {
      attrs: {
        "tileList": _vm.maxQuantity,
        "tileKeyList": _vm.maxQuantity,
        "showHeadingLabel": !_vm.buyPanelConfiguration.quantity_label_hide,
        "headingLabel": (_vm$translations4 = _vm.translations) === null || _vm$translations4 === void 0 ? void 0 : _vm$translations4.buyPanelQTY,
        "itemSelected": Number(_vm.itemsToPurchase[0].quantity),
        "buyPanelIsLoading": _vm.buyPanelIsLoading,
        "itemCustomClass": "tile-selectors__wrapper--qty"
      },
      on: {
        "on-click-item": _vm.onChangeQuantity
      }
    }) : _vm._e()], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }